import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  fetchMarketplaceCategories,
  reset,
} from '../../../services/store/modules/marketplace';
import MarketplaceListingPage from './MarketplaceListingPage/MarketplaceListingPage';
import MarketplaceListingSummaryPage from './MarketplaceListingSummaryPage/MarketplaceListingSummaryPage';
import MarketplaceSearchResultsPage from './MarketplaceSearchResultsPage/MarketplaceSearchResultsPage';
import MarketplaceCategoriesPage from './ServicesCategoriesPage/ServicesCategoriesPage';

// setting this constant here and not using useRouteMatch as it doesn't always work correctly
const marketPlaceBaseUrl = '/maps/marketplace';

const MarketplaceFeature: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMarketplaceCategories());

    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  return (
    <Switch>
      <Route path={marketPlaceBaseUrl} exact>
        <Redirect to="/maps/prepare" />
      </Route>

      <Route path={`${marketPlaceBaseUrl}/categories`} exact>
        <MarketplaceCategoriesPage />
      </Route>

      <Route path={`${marketPlaceBaseUrl}/search`} exact>
        <MarketplaceSearchResultsPage />
      </Route>

      <Route path={`${marketPlaceBaseUrl}/listing/:id/summary`} exact>
        <MarketplaceListingSummaryPage />
      </Route>

      <Route path={`${marketPlaceBaseUrl}/listing/:id`} exact>
        <MarketplaceListingPage />
      </Route>
    </Switch>
  );
};

export default MarketplaceFeature;
